export default {
  resultCode: 0,
  message: {
    title: "success",
  },
  status: "200",
  result: "OK",
  data: {
    setMenuItemList: [
            {
              setMenuIdx : 1,
              sideMenuIdx: 1,
              menuIdx: 42,
              name: "갈릭 파스타",
              price: 0,
              qty: 0,
            },
            {
              setMenuIdx : 1,
              sideMenuIdx: 1,
              menuIdx: 38,
              name: "알리오올리오 파스타",
              price: 1000,
              qty: 0,
            },
            {
              setMenuIdx : 1,
              sideMenuIdx: 1,
              menuIdx: 39,
              name: "씨푸드토마토 파스타",
              price: 1000,
              qty: 0,
            },
            {
              setMenuIdx : 1,
              sideMenuIdx: 1,
              menuIdx: 41,
              name: "쉬림프 로즈 \n파스타",
              price: 1000,
              qty: 0,
            },
            {
              setMenuIdx : 1,
              sideMenuIdx: 2,
              menuIdx: 24,
              name: "사과에이드",
              price: 0,
              qty: 0,
            },
            {
              setMenuIdx : 1,
              sideMenuIdx: 2,
              menuIdx: 26,
              name: "레몬에이드",
              price: 0,
              qty: 0,
            },
            {
              setMenuIdx : 1,
              sideMenuIdx: 2,
              menuIdx: 25,
              name: "블루레몬 에이드",
              price: 0,
              qty: 0,
            },
            {
              setMenuIdx : 1,
              sideMenuIdx: 2,
              menuIdx: 27,
              name: "오렌지에이드",
              price: 0,
              qty: 0,
            },
            {
              setMenuIdx : 1,
              sideMenuIdx: 2,
              menuIdx: 28,
              name: "레드베리\n에이드",
              price: 0,
              qty: 0,
            },
            {
              setMenuIdx : 1,
              sideMenuIdx: 3,
              menuIdx: 5,
              name: "도너츠",
              price: 2400,
              qty: 0,
            },
            {
              setMenuIdx : 1,
              sideMenuIdx: 3,
              menuIdx: 7,
              name: "바닐라스콘",
              price: 3200,
              qty: 0,
            },
            {
              setMenuIdx : 1,
              sideMenuIdx: 3,
              menuIdx: 4,
              name: "초코머핀",
              price: 3200,
              qty: 0,
            },
            {
              setMenuIdx : 1,
              sideMenuIdx: 3,
              menuIdx: 3,
              name: "초콜렛 무스케이크",
              price: 4500,
              qty: 0,
            },
            {
              setMenuIdx : 1,
              sideMenuIdx: 3,
              menuIdx: 9,
              name: "딸기 롤케이크",
              price: 4500,
              qty: 0,
            },
            {
              setMenuIdx : 1,
              sideMenuIdx: 3,
              menuIdx: 8,
              name: "딸기 조각케이크",
              price: 4800,
              qty: 0,
            },
        ]
    }
}